import { render } from "./index.vue?vue&type=template&id=38e80164&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=38e80164&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38e80164"

export default script